.root {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cover {
  background: var(--md-surface);
}

.cover .image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.inset {
  background: var(--md-surface-container);
  padding: 0.5rem;
}

.inset .image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  box-shadow: 0 1px 4px rgb(var(--shadow-color) / 0.32);
  border-radius: 1px;
}

.placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--md-surface-container);
}

.placeholderIcon {
  width: 2.5rem;
  height: 2.5rem;
  color: var(--md-outline-variant);
}
